package com.punyo.portfolio.pages.works

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initNitechvacancyviewerPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("works/nitechvacancyviewer.md", FrontMatterElement.Builder { addScalar("title", "NITechSearch：名工大の講義室使用状況検索アプリ"); }))
}

@Page("/works/nitechvacancyviewer")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun NitechvacancyviewerPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("nitechsearch-名工大の講義室使用状況検索アプリ") }) {
        org.jetbrains.compose.web.dom.Text("NITechSearch：名工大の講義室使用状況検索アプリ")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("はじめに") }) {
        org.jetbrains.compose.web.dom.Text("はじめに")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("このページでは、2024年8月～9月に制作を行い、同年10月に学内向けに")
        com.varabyte.kobweb.silk.components.navigation.Link("https://play.google.com/store/apps/details?id=com.punyo.nitechvacancyviewer") {
            org.jetbrains.compose.web.dom.Text("Google Play")
        }
        org.jetbrains.compose.web.dom.Text("にてリリースした「NITechSearch：名工大の講義室使用状況検索アプリ」の紹介を行います。")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("制作したアプリについて") }) {
        org.jetbrains.compose.web.dom.Text("制作したアプリについて")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("内容") }) {
        org.jetbrains.compose.web.dom.Text("内容")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("div", attrs = {attr("style", "display: flex; justify-content: space-between; align-items: center;")}) {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "/works/nitechvacancyviewer/featuregraphic1.png");attr("width", "49%")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "/works/nitechvacancyviewer/featuregraphic2.png");attr("width", "49%")})
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br")
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("div", attrs = {attr("style", "display: flex; align-items: center;")}) {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("video", attrs = {attr("src", "/works/nitechvacancyviewer/video.mp4");attr("controls", "");attr("width", "180")})
    }

    org.jetbrains.compose.web.dom.H4(attrs = { id("使用技術") }) {
        org.jetbrains.compose.web.dom.Text("使用技術")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("このアプリはKotlinを用いたAndroidアプリとして開発し、UIにはJetpack ComposeとMaterial Design 3を採用しました。取得した講義室予約情報はRoomで端末内に保存し、設定値はDataStore Preferencesで管理しています。また、学内システムへのログインに必要な認証情報は、Google Crypto Tinkを用いて保存時に暗号化しています。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("通信処理にはRetrofitを、学内システムから取得したHTMLの解析にはJsoupを利用しました。依存性注入にはDagger Hiltを採用し、画面・データ保存・通信処理の責務を分けながら実装しています。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("リリース後の品質改善ではFirebase CrashlyticsとAndroid Vitalsを活用し、ユーザー環境で発生したクラッシュを確認しながら安定性の改善を行いました。さらに、GitHub ActionsとGoogle Play Developer APIを用いてAABファイルのビルドからGoogle Playへのデプロイまでを自動化し、公開作業の効率化にも取り組みました。")
    }
    org.jetbrains.compose.web.dom.H4(attrs = { id("動機") }) {
        org.jetbrains.compose.web.dom.Text("動機")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("筆者は以前から「学内システムの情報を使って何かできないかなあ...？」と考えていました. ちょうどその時、SNSで弊学学生による以下のような投稿を見かけました. なお、以下の文章は原文から一部改変したものとなります.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("今どの教室があいてるかリアルタイムで知ることができたらなあ...？")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("この投稿からアイデアをもらい、前述したようなアプリを制作しました. また、同期からも「毎回ログインしないと空室状況を確認できないのが面倒」という声を聞いており、単なる技術検証ではなく、身近な利用者の不便を解消するためのプロダクトとして開発することを意識しました。")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("制作過程について") }) {
        org.jetbrains.compose.web.dom.Text("制作過程について")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("筆者はUIをある程度まで問題なく完成させることができました。 しかし、ここでこのアプリを制作する過程で避けられない最大の問題が浮上しました。 それは、")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("「どのようにして空室状況を取得するのか」")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("という問題です. 今空いている講義室を判定するためには少なくとも現在の講義室の予約情報を手に入れなければなりません. しかし、講義室の予約情報を取得するAPIは（筆者の知る限りでは）存在しません. そこで筆者は予約情報の確認ができる学内システムのページからスクレイピングで強引に講義室の予約情報を取得しようと試みました。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("スクレイピングを行うにあたって、ここでもう一つの問題が浮上します。 それは「どのようにしてアプリから学内システムの認証を行うか」という問題です。 適切な認証なしでアクセスしようとするとログイン画面へリダイレクトされてしまいます。 この問題を解決するために、認証～学内システムへのログインまでの通信を調べ認証方法に関しての検証を行いました。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("検証によって得られたログインまでの詳細を以下の図に示します。 （括弧内のダブルクォーテーションで囲まれた文字列はそれらのメッセージ内での名称を表しています）")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/works/nitechvacancyviewer/authchart.png", "認証概略図")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("これらを踏まえて、RetrofitとJsoupを用いて認証とHTMLの解析を実装しました。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("前述したものをすべて実装した後、学内システムにアクセスするための認証情報をユーザーに要求するログイン画面、Tinkを用いて保存時に認証情報を暗号化する機能、Roomを用いて取得した予約情報を内部のDBに保存する機能を実装して、最終的に講義室の予約情報を取得する処理は以下のフローチャートのようになりました。")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/works/nitechvacancyviewer/flowchart.png", "フローチャート")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("こうして取得した予約情報を端末内に保存することで、ユーザーは毎回学内システムにログインし直さなくても、保存済みの予約状況をもとに空室情報を確認できるようになりました。実装にあたっては、認証情報を扱うため、利便性だけでなく安全な保存方法にも注意しました。")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("公開と運用について") }) {
        org.jetbrains.compose.web.dom.Text("公開と運用について")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("完成後はGoogle Playで学内向けに公開しました。公開して終わりではなく、リリース後にCrashlyticsやAndroid Vitalsでクラッシュ情報を確認し、実際のユーザー環境で起きた問題の原因を調査して修正する流れを経験しました。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("また、GitHub Actionsによる本番環境へのデプロイ自動化も導入しました。以前のアプリ開発では手作業で行っていた工程を自動化したことで、リリース作業の負担を減らし、修正後に素早く配布できる体制を整えることができました。")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("さいごに") }) {
        org.jetbrains.compose.web.dom.Text("さいごに")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("最後にAndroidアプリを作ってから期間が大きく空いていたため、制作前に現在広く使われるライブラリや実装についての学習を行いました。これらの過程のおかげでブランクを埋められただけではなく、学習後に以前の成果物のコードを見直すことにより ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/Punyo/AndroidApp/blob/master/AndroidApp/MainActivity.cs") {
            org.jetbrains.compose.web.dom.Text("肥大化したMainActivity")
        }
        org.jetbrains.compose.web.dom.Text(" など、高校生の時に書いたコードの問題点を実感することができました。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("UIデザインに関しても、Material Design 3を取り入れたり、学内でよく使われている青色を基調としたデザインを採用するなど、")
        com.varabyte.kobweb.silk.components.navigation.Link("/works/jikanwariandtodo/screenshot1.png") {
            org.jetbrains.compose.web.dom.Text("以前のアプリ")
        }
        org.jetbrains.compose.web.dom.Text(" よりもさらに配慮ができたと感じています。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("さらに、アプリをリリース後、実際のユーザー環境で発生した不具合の原因を分析することで、実務に近い経験を積むことができました。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("この開発を通じて、利用者の声から課題を見つけ、設計・実装・公開・運用まで一連の流れを経験できました。特に、同期から喜びの声を聞けたことで、プロダクトを実際に届けることの難しさだけでなく、使ってもらえるものを作るやりがいも学ぶことができました。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("今後はここからさらに開発を進め、以前のコードを見直すことにより得られた反省点や実務に従事されている先輩から貰ったアドバイスをもとにして自分自身の技術力をさらに向上させていきたいと思います。")
    }
}
